<!-- 独立菜单权限树 -->
<template>
    <div>
        <el-tree  ref="authTree" :data="menuList" :props="defaultProps" show-checkbox node-key="menuId" default-expand-all :default-checked-keys="chooseMenu" @check="handleCheckChange">
            <span class="custom-tree-node" slot-scope="{ node,data }">
              <span>
                  <i :class="data.menuIco"></i> {{ node.label }}
                  <span v-if="data.menuType == 'menu'" style="color: #0F81FB;">(菜单)</span>
                  <span v-if="data.menuType == 'button'" style="color: #E6A23C;">(按钮)</span>
                  <span v-if="data.menuType == 'auth'" style="color: #47B267;">(授权)</span>
              </span>
            </span>
        </el-tree>
        <div style="display: flex; justify-content: flex-end;">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="commit">授权</el-button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "authTree",
    data(){
        return{
            defaultProps: {
                children: 'nodes',
                label: 'menuName'
            },
            menuList: [],
            chooseMenu: [],
            userData: {},
            operateData: [],
        }
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ])
    },
    methods: {
        // 获取菜单列表
        getMenuList() {
            this.$api.menuSelectByUserId(this.userInfo.userId).then(res=>{
                if(res.errcode != 0) return false;
                let menuListSource = res.data
                this.menuList = this.translateDataToTree(menuListSource);
            })
        },
        // 打开授权树
        open(param){
            this.userData = param;
            this.getMenuList();
            function getCheckedMenuList(menuList){
                let hasChoose = [];
                function check(menuList){
                    for(let menu of menuList){
                        if(menu.nodes == null){
                            hasChoose.push(menu.menuId);
                        }else{
                            check(menu.nodes);
                        }
                    }
                }
                check(menuList);
                return hasChoose;
            }

            // this.$api.independentMenuSelectByUserId(param.userId).then(res => {
            this.$api.menuSelectByUserId(param.userId).then(res=>{
                if(res.errcode != 0) return false;
                // console.log(`品牌已有菜单`, res.data);
                let menuListSource = res.data
                let userMenuList = this.translateDataToTree(menuListSource);

                this.chooseMenu = getCheckedMenuList(userMenuList);
                this.operateData = [...this.chooseMenu];
                this.$nextTick(() => {
                    this.$refs.authTree.setCheckedKeys(this.chooseMenu)
                });
            })
        },

        translateDataToTree(arr) {
            return arr.filter((father) => {
                let branchArr = arr.filter((child) => father.menuId == child.parentMenuId)
                branchArr.length > 0 ? father.nodes = branchArr : ''
                return father.parentMenuId == ''
            })
        },
        // 授权菜单点击
        handleCheckChange(data, checked, indeterminate) {
            this.operateData  = checked.checkedKeys.concat(checked.halfCheckedKeys);
        },
        // 更改独立授权
        commit(){
            console.log(this.userData);
            this.$api.userManageUpdateUserOwnMenuList ({
                ...this.userData,
                menuList: this.operateData
            }).then(res=> {
                if(res.errcode != 0) return false;
                this.$message.success(res.errmsg)
                this.handleClose();
            }).finally(()=>{
                this.open(this.userData);
            })
        },
        handleClose(){
            this.$emit("cancel");
        }
    }
}
</script>

<style lang="sass" scoped>
    
</style>